export default [
  {
    "x": 3.02883336,
    "y": 4.45176703,
    "angle": -0.9924226018432213,
    "lengthA": 10.931598708624433,
    "lengthB": 10.931598700250904
  },
  {
    "x": 3.02883336,
    "y": 78.164767,
    "angle": -1.7326355751894031,
    "lengthA": 9.474664038819837,
    "lengthB": 9.4746640372085
  },
  {
    "x": 17.3248334,
    "y": 92.013767,
    "angle": -2.7263988357552416,
    "lengthA": 7.860442799945579,
    "lengthB": 7.860442840282308
  },
  {
    "x": 86.5708334,
    "y": 92.013767,
    "angle": 2.8559960636455703,
    "lengthA": 11.2542023780912,
    "lengthB": 11.25420225396884
  },
  {
    "x": 89.5965398,
    "y": 7.58098526,
    "angle": 1.2543351529870572,
    "lengthA": 17.881703416605955,
    "lengthB": 5.605259787737038
  }
]